'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require('react-redux');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactScroll = require('react-scroll');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _ = require('../');
var _propertyDetails = require('../../redux/modules/propertyDetails');
var _messageModal = require('../../redux/modules/messageModal');

var _ReportProperty = require('./ReportProperty.scss');var styles = _interopRequireWildcard(_ReportProperty);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

ReportProperty = function (_Component) {_inherits(ReportProperty, _Component);function ReportProperty() {var _temp, _this, _ret;_classCallCheck(this, ReportProperty);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      formOpen: false }, _this.
























    report = function (_ref) {var reason = _ref.reason,issue = _ref.issue,captcha = _ref.captcha;var _this$props =
      _this.props,locale = _this$props.locale,propertyId = _this$props.propertyId,userData = _this$props.userData;var _ref2 =
      !!userData && userData || {},email = _ref2.email,display_name = _ref2.display_name,id = _ref2.id;

      _this.props.reportProperty({
        captcha: captcha,
        reason: reason,
        issue: issue,
        locale: locale,
        email: email,
        property_id: propertyId,
        name: display_name,
        user_id: id });

    }, _this.

    hideForm = function () {return _this.setState({ formOpen: false });}, _this.

    scrollToBottom = function () {
      _this.height = _this.height || document && document.documentElement.clientHeight;
      var offset = 45 - _this.height;

      _reactScroll.scroller.scrollTo('reportProperty', {
        duration: 500,
        offset: offset,
        smooth: true });

    }, _temp), _possibleConstructorReturn(_this, _ret);}ReportProperty.prototype.componentDidMount = function componentDidMount() {document.addEventListener('click', this.hideForm);};ReportProperty.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {var reportSending = _ref3.reportSending,reportSendingError = _ref3.reportSendingError;if (this.props.reportSending && !reportSending && !reportSendingError) {this.setState({ formOpen: false });this.props.openMessageModal({ message: _react2.default.createElement('div', { className: 'successMessage' }, _react2.default.createElement('span', null, this.props.translate('successMessage'))), messageModalClassName: 'report-success-modal' });}};ReportProperty.prototype.componentWillUnmount = function componentWillUnmount() {document.removeEventListener('click', this.hideForm);};ReportProperty.prototype.

  render = function render() {var _this2 = this,_cx,_cx2,_cx3;var _props =
    this.props,translate = _props.translate,isActive = _props.isActive,isPreview = _props.isPreview,isForeign = _props.isForeign;

    return (
      _react2.default.createElement('div', {
          ref: function ref(_ref4) {_this2.reportProperty = _ref4;},
          className: styles.reportProperty,
          onClick: function onClick(evt) {return evt.nativeEvent.stopImmediatePropagation();} },

        _react2.default.createElement('button', {
            type: 'button',
            onClick: function onClick() {
              if (_this2.props.isMobile && !_this2.state.formOpen) {
                _this2.scrollToBottom();
              }
              _this2.setState({ formOpen: !_this2.state.formOpen });
            },
            className: (0, _classnames2.default)(
            styles.reportButton, (_cx = {}, _cx[
            styles.opened] = this.state.formOpen, _cx), (_cx2 = {}, _cx2[
            styles.reportForeign] = isForeign, _cx2)) },


          translate('buttonText')),


        this.state.formOpen &&
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.reportFormWrapper, (_cx3 = {}, _cx3[styles.mobileStyle] = this.props.mobileStyle, _cx3)) },
          _react2.default.createElement(_.ReportPropertyForm, { translate: translate, onSubmit: this.report, reportSending: this.props.reportSending }))));




  };return ReportProperty;}(_react.Component);


ReportProperty.propTypes = {
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  propertyId: _propTypes2.default.string,
  userData: _propTypes2.default.object,
  reportProperty: _propTypes2.default.func,
  reportSending: _propTypes2.default.bool,
  reportSendingError: _propTypes2.default.object,
  mobileStyle: _propTypes2.default.bool,
  isActive: _propTypes2.default.bool,
  isPreview: _propTypes2.default.bool,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  isForeign: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(_ref5) {var
  lang = _ref5.lang,
  propertyDetails = _ref5.propertyDetails,
  userAuthentication = _ref5.userAuthentication;return (
    {
      locale: lang.locale,
      propertyId: propertyDetails.propertyId,
      userData: userAuthentication.data,
      reportSending: propertyDetails.reportSending,
      reportSendingError: propertyDetails.reportSendingError,
      isActive: (0, _get2.default)(propertyDetails, 'data.is_active'),
      isPreview: (0, _get2.default)(propertyDetails, 'isPreview') });};exports.default =


(0, _reactRedux.connect)(mapStateToProps, { reportProperty: _propertyDetails.reportProperty, openMessageModal: _messageModal.openMessageModal, hideMessageModal: _messageModal.hideMessageModal })(
ReportProperty);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportProperty/ReportProperty.js
// module id = 2874
// module chunks = 0